import { render } from "./infoBlock.vue?vue&type=template&id=1c25257b&scoped=true"
import script from "./infoBlock.vue?vue&type=script&lang=js"
export * from "./infoBlock.vue?vue&type=script&lang=js"

import "./infoBlock.vue?vue&type=style&index=0&id=1c25257b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c25257b"]])

export default __exports__